import * as React from 'react';
import { DatePicker as SitDatePicker, DateRange } from 'Src/components/DatePicker/DatePicker';

type Props = {
  bookingOpensAt: Date | null;
  bookingClosesAt: Date | null;
  minDate: Date;
  opensError?: string;
  closesError?: string;
  isOpensInvalid: boolean;
  isClosesInvalid: boolean;
  isOpensDisabled?: boolean;
  isClosesDisabled?: boolean;
  onChangeOpens: (dt: Date | null) => void;
  onChangeCloses: (dt: Date | null) => void;
};

export const ClubProgrammeBookingWindowFields: React.FC<Props> = ({
  bookingOpensAt,
  bookingClosesAt,
  minDate,
  opensError,
  closesError,
  isOpensInvalid,
  isClosesInvalid,
  isOpensDisabled = false,
  isClosesDisabled = false,
  onChangeOpens,
  onChangeCloses
}) => {
  const asDate = (value: Date | DateRange | null): Date | null => (value instanceof Date ? value : null);

  return (
    <div className="eCpfField eCpfColSpan2">
      <div className="eCpfTwoCols">
        <div className="eCpfField">
          <SitDatePicker
            label="Booking opens"
            mode="datetime"
            value={bookingOpensAt}
            onChange={value => onChangeOpens(asDate(value))}
            placeholder="Select date and time"
            format="DD MMM YYYY · HH:mm"
            min={minDate}
            minuteStep={5}
            required
            disabled={isOpensDisabled}
            clearable={!isOpensDisabled}
            centered
            error={isOpensInvalid ? opensError : undefined}
            className="cpEditorDateTimePicker"
          />
        </div>

        <div className="eCpfField">
          <SitDatePicker
            label="Booking closes"
            mode="datetime"
            value={bookingClosesAt}
            onChange={value => onChangeCloses(asDate(value))}
            placeholder="Select date and time"
            format="DD MMM YYYY · HH:mm"
            min={bookingOpensAt || minDate}
            minuteStep={5}
            required
            disabled={isClosesDisabled}
            clearable={!isClosesDisabled}
            centered
            error={isClosesInvalid ? closesError : undefined}
            className="cpEditorDateTimePicker"
          />
        </div>
      </div>
    </div>
  );
};

ClubProgrammeBookingWindowFields.displayName = 'ClubProgrammeBookingWindowFields';
